/// <reference path="./include/global.d.ts" />

/** Imports */
import { PageAbstract, waitLangText } from './abs/pageAbstract';
import { Buscador } from './include/buscador/buscador';
import { Comentarios } from './include/comentarios';

/** Dependencias */
import '../stylus/home.sass'
import '../assets/fonts/custom_icons/custom_icons.styl'
import '../librerias/OwlCarousel/assets/owl.carousel.min.css'
import '../librerias/OwlCarousel/assets/owl.theme.default.min.css'

// La parte JS pesada de OwlCarousel y Bootstrap se carga de forma diferida
// cuando realmente se necesita, para reducir Script Evaluation en el primer load.

export class Home extends PageAbstract  {

    /** constructor */
    constructor() {
        super();
    }

    init(){
        // Telemetría: entrada a home
        (window as any).telemetry?.send('paso1', {
            page_type: 'home'
        });

        // Web Vitals: capturar métricas de rendimiento
        (window as any).WebVitalsObserver?.captureHomePageVitals((window as any).telemetry, 'home');

        let buscador = new Buscador();
        buscador.iniciar();
    }

	loadDeferred(){
		// Cargar JS de OwlCarousel y Bootstrap solo si existe al menos un carrusel en la página.
		const hasCarousels =
			$('.carousel-rentadoras').length > 0 ||
			$('.carousel-medios').length > 0;

		const loadOwlAndBootstrap = hasCarousels
			? Promise.all([
					import(/* webpackChunkName: "owl-carousel" */ '../librerias/OwlCarousel/owl.carousel.min.js'),
					import(/* webpackChunkName: "bootstrap-core-home" */ 'bootstrap/js/dist/carousel'),
					import(/* webpackChunkName: "bootstrap-core-home" */ 'bootstrap/js/dist/collapse'),
					import(/* webpackChunkName: "bootstrap-core-home" */ 'bootstrap/js/dist/modal'),
					import(/* webpackChunkName: "bootstrap-core-home" */ 'bootstrap/js/dist/tab'),
			  ])
			: Promise.resolve();

		loadOwlAndBootstrap.then(() => {
			if ($('.carousel-rentadoras').length) {
				$('.carousel-rentadoras').owlCarousel({
					loop: false,
					margin: 0,
					dots: false,
					nav: false,
					autoplay: true,
					autoplayTimeout: 2000,
					autoplayHoverPause: true,
					responsive: {
						0: { items: 2 },
						600: { items: 3 },
						1280: { items: 5 },
						1400: { items: 6 }
					}
				});
			}
			
			this.hoverCards();
			this.listenOfertas();
			this.listenFaqs();
			this.initCarouselMedios();

			// Asegurar que x_textos esté disponible antes de llamar a Comentarios
			waitLangText(() => {
				new Comentarios().setVerMas();
			});
		});
	}

	listenFaqs(){
		$('.faq').on('click', function () {
			var $icon = $(this).find('.alk');  // Buscar el elemento i con la clase alk dentro del elemento faq
			// Verificar si el elemento está colapsado
			if ($(this).hasClass('collapsed')) {
			  // El elemento está colapsado, cambiar clases del ícono
			  $icon.removeClass('alk-angle-up').addClass('alk-angle-down');
			} else {
			  // El elemento no está colapsado, cambiar clases del ícono
			  $icon.removeClass('alk-angle-down').addClass('alk-angle-up');
			}
		 });
	}


	hoverCards() {
		$(".card").on({
			click: function(e) {
				if(e.target.className == 'alk alk-close'){
					e.preventDefault();
					e.stopPropagation();
				}
			  	$(this).toggleClass('active');
			},
			mouseenter: function() {
			  	$(this).addClass('active');
			},
			mouseleave: function() {
			  	$(this).removeClass('active');
			}
		});
	}

	listenOfertas(){
		let self = this;
		//Subscribe
		$(document).on('submit', '#form-correo', function (event) {
			event.preventDefault();
			event.stopPropagation();
			let $esto = $(this)
			let config = { dir: '/action/subscribe/', type: 'POST' }
				, args = { email: $esto.find('[name="email"]').val() }
				, $btn_accion = $('#enviar-correo')
				, $modal = $('[data-remodal-id="modal-mensaje"]')
	
			$btn_accion.addClass('desactivar').text(x_textos['568-0'])
	
			$modal.find('.title').text(x_textos['434-0'])
	
			self.utils.jSONInfo(config, args, function (data: any) {
				$btn_accion.removeClass('desactivar').text(x_textos['F80-0']).prop('disabled', false);
				self.utils.sendMsjModal(x_textos["2174-0"], x_textos['550-0'], true, false);
				$('#form-correo').trigger("reset");
			});
		}); 
	}

	initCarouselMedios(){
		$('.carousel-medios').owlCarousel({
			loop:true,
			nav:true,
			dots: false,
			margin:6,
			navText: [
                '<i class="alk alk-angle-left" id="icon-prev" aria-label="Previo"  ></i>',
                '<i class="alk alk-angle-right" id="icon-next" aria-label="Siguiente" ></i>',
            ],
			responsive:{
				0:{
					items:1
				},
				600:{
					items:3
				},
				1000:{
					items:3
				}
			}
		});

		var ariaLabelIcono = $("#icon-prev").attr("aria-label");
		var ariaLabelIconoNext = $("#icon-next").attr("aria-label");

		// Encuentra el botón padre del icono y asigna el mismo aria-label
		$("#icon-prev").parent(".owl-prev").attr("aria-label", ariaLabelIcono ? ariaLabelIcono :'');
		$("#icon-prev").parent(".owl-prev").attr("role", 'button');
		$("#icon-next").parent(".owl-next").attr("aria-label", ariaLabelIconoNext ? ariaLabelIconoNext :'');
		$("#icon-next").parent(".owl-next").attr("role", 'button');
	}

}

var instance: Home = new Home();
var loadDeferredHandled: boolean  = false;

$(function() {
	waitLangText(() => {
		instance.init();
	});
});

const handleUserFirstInteraction = () => {
    if (!loadDeferredHandled) {
        loadDeferredHandled = true;
        instance.loadDeferred();
        window.removeEventListener('scroll', onScroll, { capture: true } as any);
        document.removeEventListener('click', onClick, true);
    }
};

const onScroll = () => handleUserFirstInteraction();
const onClick = () => handleUserFirstInteraction();

// Listeners globales muy baratos, solo para detectar la primera interacción.
window.addEventListener('scroll', onScroll, { passive: true });
document.addEventListener('click', onClick, true);




